import { render, staticRenderFns } from "./PagamentoOnline.vue?vue&type=template&id=64ba1f98&"
import script from "./PagamentoOnline.vue?vue&type=script&lang=js&"
export * from "./PagamentoOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports